import React from 'react';
import { motion } from 'framer-motion';
type SectionHeadingProps = {
  label: string;
  title?: string;
  subtitle?: string;
  align?: 'left' | 'center';
};
export function SectionHeading({
  label,
  title,
  subtitle,
  align = 'left'
}: SectionHeadingProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className={align === 'center' ? 'text-center' : ''} data-id="element-211" data-mp="w17fc9gs1ip4">
      <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-212" data-mp="i76ftdi03rnp">
        <span className="h-px w-8 bg-ink-700" aria-hidden="true" data-id="element-213" data-mp="d9epgnx08dlm" />
        <span className="text-[11px] font-bold uppercase tracking-[0.28em] text-ash" data-id="element-214" data-mp="8ajvqqxi14mq">
          {label}
        </span>
      </div>
      {title ? <h2 className="display mt-5 text-3xl text-bone sm:text-4xl md:text-5xl" data-id="element-215" data-mp="4a9m94ahzw34">{title}</h2> : null}
      {subtitle ? <p className="mt-4 max-w-2xl text-base leading-relaxed text-ash sm:text-lg" data-id="element-216" data-mp="1e0syq44oxp9d">
          {subtitle}
        </p> : null}
    </motion.div>;
}